import { UserRole } from 'enums';

import { useUserContext } from './use-user-context.hook';

export const useUser = () => {
  const { user } = useUserContext();
  return {
    user,
    userId: user.id,
    role: user.role,
    apiRole:
      user.role === UserRole.MerchantOperator ? UserRole.Merchant : user.role,
    isAdmin: user.role === UserRole.Admin,
    isOperator: user.role === UserRole.Operator,
    isTechOperator: user.role === UserRole.TechOperator,
    isTrader: user.role === UserRole.Trader,
    isMerchant: user.role === UserRole.Merchant,
    isMerchantOperator: user.role === UserRole.MerchantOperator,
    isAdminOrTechOperator: [UserRole.Admin, UserRole.TechOperator].includes(
      user.role,
    ),
    isManager: [
      UserRole.Operator,
      UserRole.Admin,
      UserRole.TechOperator,
    ].includes(user.role),
  };
};
